module.exports = __webpack_public_path__ + "img/nb_2.046c8849.png";